import React from 'react'
import { Modal } from '@mantine/core'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

type HistogramModalProps = {
  opened: boolean
  onClose: () => void
  histogram: {
    counts: number[]
    binEdges: number[]
  }
}

export const HistogramModal = ({ opened, onClose, histogram }: HistogramModalProps) => {
    const { counts, binEdges } = histogram

    const options: Highcharts.Options = {
      chart: {
        type: 'column',
      },
      title: {
        text: 'Vector Similarities',
      },
      xAxis: {
        title: {
          text: 'Similarity Ranking',
        },
        categories: binEdges.slice(0, -1).map((edge, index) => `${edge} - ${binEdges[index + 1]}`),
      },
      yAxis: {
        title: {
          text: 'Counts',
        },
      },
      series: [
        {
          name: 'Count',
          type: 'column',
          data: counts,
        },
      ],
    };

  return (
    <Modal size='90%' opened={opened} onClose={onClose}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Modal>
  )
}
